const EmptyComponent = () => {
    return <></>;
};

export default EmptyComponent;
